/**
 * @description List of locales supported by the library, for compile time checks.
 */
export const DefaultLocales = [
  "ar",
  "bg",
  "cs",
  "da",
  "de",
  "el",
  "en-GB",
  "en-US",
  "es-ES",
  "es",
  "fi",
  "fr-CA",
  "fr",
  "ga",
  "hr",
  "hu",
  "id",
  "it",
  "iw",
  "ja",
  "ko",
  "lo",
  "lt",
  "ms",
  "nl",
  "nl-BE",
  "no",
  "pl",
  "pt-BR",
  "pt",
  "ro",
  "ru",
  "sk",
  "sl",
  "sr",
  "sv",
  "uk",
  "ur",
  "vi",
  "th",
  "tr",
  "zh-HK",
  "zh",
  "zu",
] as const;

/**
 * @description Mutable list of locales supported by the library, for runtime checks.
 */
export const Locales = [...DefaultLocales];
